import { AnyAction } from 'redux';

import { DEMAND_DETAIL_POSITIONS_RECEIVE, DEMAND_DETAIL_POSITIONS_SUBMIT } from './demand-detail-positions-actions';
import { DEMAND_DETAIL_RESET } from '../demand-detail-actions';
import { Demand } from '../../../../models/demand';
import { PositionsFormValues } from '../../models/positions-form-values';
import { StepData } from '../../../../../../common/components/new-stepper/step-data';

export interface DemandDetailPositionsReducerState {
    stepData: StepData<PositionsFormValues>;
    /**
     * The step as the server last handed it over (#2159). `stepData.values`
     * cannot serve: leaving a wizard step parks its input right there.
     */
    baseline?: PositionsFormValues;
}

export const initialDemandDetailPositionsReducerState: DemandDetailPositionsReducerState = {
    stepData: {
        errors: {},
        values: { demandItems: [], startDate: new Date() },
        isValid: false,
        isDirty: false,
    },
};

export const demandDetailPositionsReducer = (
    state: DemandDetailPositionsReducerState = initialDemandDetailPositionsReducerState,
    action: AnyAction
): DemandDetailPositionsReducerState => {
    const { type } = action;

    switch (type) {
        case DEMAND_DETAIL_POSITIONS_SUBMIT: {
            const data = action['data'] as StepData<PositionsFormValues>;
            return {
                ...state,
                stepData: {
                    ...state.stepData,
                    ...data,
                },
            };
        }

        case DEMAND_DETAIL_POSITIONS_RECEIVE: {
            const demand = action['demand'] as Demand;
            const values = {
                demandItems: demand.demandItems,
                startDate: demand.startDate,
                deliveryDateFrom: demand.deliveryDateFrom,
                deliveryDateTo: demand.deliveryDateTo,
            };

            return {
                ...state,
                stepData: {
                    ...state.stepData,
                    isValid: true,
                    values,
                },
                // The same values, kept apart from the ones the wizard edits.
                baseline: values,
            };
        }

        case DEMAND_DETAIL_RESET: {
            return initialDemandDetailPositionsReducerState;
        }

        default: {
            return state;
        }
    }
};
